// // src/pages/treatments/BoneMarrowTransplantPage.jsx
// import React from "react";
// import TreatmentTemplate from "./TreatmentTemplate";
// import { Award, Users, Shield, Clock, Calendar, Activity, ThumbsUp, Heart, Droplets } from "lucide-react";

// const BONE_MARROW_TREATMENT = {
//   slug: "bone-marrow-transplant",
//   name: "Bone Marrow Transplant",
//   shortName: "BMT",
//   tagline: "A Second Chance at Life",
//   heroSubtag: "Save 70–80% on BMT. World-class haematology centres. No waiting list for donors.",
//   description:
//     "Comprehensive bone marrow transplant services including autologous and allogeneic transplants for leukaemia, lymphoma, thalassaemia, and other blood disorders. Our centres perform over 500 transplants annually with outcomes matching leading US and European centres, supported by dedicated stem cell laboratories and 24/7 haematology intensivist coverage.",
//   heroImage: "/BoneMarrow.jpeg", 
//   category: "Haematology & Oncology",
//   badge: "Life-Saving",
//   accentColor: "red",
//   costCard: {
//     label: "Complete BMT package (autologous)",
//     value: "₹12L–₹18L",
//     compare: "vs. ₹45L+ in the UK",
//     stay: "4–6 weeks isolation + 4–8 weeks recovery",
//     stayCompare: "vs. $250,000–$500,000 in the US",
//   },
//   stats: [
//     { label: "Success Rate", value: "85%+", icon: Award },
//     { label: "Transplants/Year", value: "500+", icon: Users },
//     { label: "Years Experience", value: "25+", icon: Shield },
//     { label: "ICU Stay", value: "2-4 Weeks", icon: Clock },
//   ],
//   benefits: [
//     "Autologous & allogeneic (matched sibling, matched unrelated, haploidentical) transplants",
//     "Dedicated BMT units with HEPA filtration and positive pressure isolation rooms",
//     "Stem cell harvesting and cryopreservation on-site",
//     "24/7 haematology intensive care specialist coverage",
//     "Comprehensive pre-transplant workup and conditioning protocols",
//     "Nutritional support including parenteral nutrition when needed",
//     "Post-transplant monitoring and long-term follow-up programme",
//     "Insurance pre-authorisation and international patient support",
//   ],
//   procedure: [
//     {
//       step: "01",
//       title: "Evaluation & Workup",
//       desc: "HLA typing, disease staging, organ function tests, and donor search.",
//       duration: "2-4 Weeks",
//       icon: Calendar,
//     },
//     {
//       step: "02",
//       title: "Stem Cell Harvesting",
//       desc: "Peripheral blood stem cell collection or bone marrow harvest under anaesthesia.",
//       duration: "1-2 Days",
//       icon: Activity,
//     },
//     {
//       step: "03",
//       title: "Conditioning & Transplant",
//       desc: "Chemotherapy/radiation conditioning followed by stem cell infusion.",
//       duration: "7-10 Days",
//       icon: ThumbsUp,
//     },
//     {
//       step: "04",
//       title: "Engraftment & Recovery",
//       desc: "Neutrophil/platelet engraftment, infection prevention, and gradual recovery.",
//       duration: "4-8 Weeks",
//       icon: Heart,
//     },
//   ],
//   faqs: [
//     {
//       q: "What is the difference between autologous and allogeneic BMT?",
//       a: "Autologous transplant uses your own stem cells (harvested before high-dose chemo). Allogeneic transplant uses stem cells from a donor — usually a matched sibling or unrelated donor. The choice depends on your disease, age, and overall health.",
//     },
//     {
//       q: "How long does recovery take after BMT?",
//       a: "Hospital stay is typically 4-6 weeks for isolation and monitoring. Full immune recovery takes 6-12 months. Most patients return to normal activities within 3-6 months, but regular follow-up is essential for at least 2 years.",
//     },
//     {
//       q: "What are the success rates for BMT in India?",
//       a: "Success rates vary by disease and transplant type. For autologous transplants in multiple myeloma, 5-year survival exceeds 80%. For allogeneic transplants in leukaemia, 5-year survival ranges from 50-70% — comparable to leading Western centres.",
//     },
//     {
//       q: "Can international patients find matching donors in India?",
//       a: "Yes. India has a large and diverse stem cell donor registry. For patients requiring haploidentical (half-matched) transplants, India's large population often yields suitable family donors. We also coordinate with international registries when needed.",
//     },
//     {
//       q: "What support is available for international patients?",
//       a: "PaxGrow provides complete support including visa assistance, airport pickup, accommodation near the hospital for accompanying family, translation services, daily updates to family back home, and telemedicine follow-up after returning home.",
//     },
//   ],
//   doctors: [
//     {
//       name: "Dr. Punit Jain",
//       specialty: "Haematologist & BMT Physician",
//       experience: "22 Years",
//       rating: 4.9,
//       reviews: 1800,
//       image: "https://randomuser.me/api/portraits/men/41.jpg",
//       qualifications: "MBBS, MD, DM (Clinical Haematology)",
//       hospital: "Apollo Hospitals, Chennai",
//     },
//     {
//       name: "Dr. Reena Nair",
//       specialty: "Haematologist & BMT Specialist",
//       experience: "28 Years",
//       rating: 4.9,
//       reviews: 2200,
//       image: "https://randomuser.me/api/portraits/women/51.jpg",
//       qualifications: "MBBS, MD, FRCP (Glasg)",
//       hospital: "Tata Medical Center, Kolkata",
//     },
//     {
//       name: "Dr. Manoj Kumar",
//       specialty: "Paediatric Haematologist & BMT Physician",
//       experience: "18 Years",
//       rating: 4.8,
//       reviews: 1600,
//       image: "https://randomuser.me/api/portraits/men/61.jpg",
//       qualifications: "MBBS, MD, DM (Paediatric Haematology-Oncology)",
//       hospital: "Fortis Memorial Research Institute, Gurugram",
//     },
//   ],
//   testimonials: [
//     {
//       name: "Ahmed Hassan",
//       age: 45,
//       location: "Nairobi, Kenya",
//       text: "Diagnosed with multiple myeloma. My doctors back home said BMT was my best chance but the cost was prohibitive. PaxGrow arranged everything — from evaluation to transplant and follow-up. Today I'm in remission. Grateful beyond words.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/men/71.jpg",
//       treatment: "Autologous BMT for Multiple Myeloma",
//       date: "October 2023",
//     },
//     {
//       name: "Fatima Begum",
//       age: 32,
//       location: "Dhaka, Bangladesh",
//       text: "My 6-year-old daughter needed a bone marrow transplant for thalassaemia. The team found a matched unrelated donor and the transplant was successful. The care during isolation was exceptional. We never felt alone.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/women/62.jpg",
//       treatment: "Allogeneic BMT for Thalassaemia",
//       date: "February 2024",
//     },
//     {
//       name: "Michael Okafor",
//       age: 38,
//       location: "Lagos, Nigeria",
//       text: "Four rounds of chemotherapy failed to control my lymphoma. The allogeneic transplant was intense, but the medical team supported me through every complication. One year post-transplant, I'm cancer-free and back to work.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/men/81.jpg",
//       treatment: "Allogeneic BMT for Lymphoma",
//       date: "June 2023",
//     },
//   ],
// };

// const BONE_MARROW_PAXGROW = {
//   whyIndiaSubtitle: "WHY PAXGROW + INDIA",
//   whyIndiaTitle: "Why International Patients Choose India for BMT",
//   whyIndiaReasons: [
//     "India performs 2,500+ BMTs annually with outcomes matching Western centres",
//     "JCI/NABH accredited BMT units with dedicated isolation facilities",
//     "Haematologists trained at leading US and UK transplant centres",
//     "Cost savings of 70–80% including donor search and stem cell processing",
//   ],
//   conditionsTitle: "Conditions Treated with Bone Marrow Transplant",
//   conditions: [
//     "Acute Leukaemia (AML, ALL)",
//     "Chronic Leukaemia (CML, CLL)",
//     "Lymphoma (Hodgkin & Non-Hodgkin)",
//     "Multiple Myeloma",
//     "Thalassaemia Major",
//     "Sickle Cell Disease",
//     "Aplastic Anaemia",
//     "Myelodysplastic Syndrome (MDS)",
//     "Severe Combined Immunodeficiency (SCID)",
//     "Autoimmune Disorders (selected cases)",
//   ],
//   stayValue: "4–6 weeks hospital + 4–8 weeks recovery in India (total 8–14 weeks recommended)",
//   costTitle: "Why India for Bone Marrow Transplant?",
//   costRows: [
//     {
//       procedure: "Autologous BMT (including stem cell harvest)",
//       india: "₹12L – ₹18L",
//       africa: "$35,000–$60,000",
//       ukusa: "$150,000–$300,000",
//     },
//     {
//       procedure: "Allogeneic BMT (matched sibling donor)",
//       india: "₹15L – ₹22L",
//       africa: "$45,000–$75,000",
//       ukusa: "$250,000–$500,000",
//     },
//     {
//       procedure: "Allogeneic BMT (matched unrelated donor)",
//       india: "₹18L – ₹28L",
//       africa: "$55,000–$100,000",
//       ukusa: "$300,000–$600,000",
//     },
//   ],
// };

// const BoneMarrowTransplantPage = () => {
//   return <TreatmentTemplate treatment={BONE_MARROW_TREATMENT} paxgrowData={BONE_MARROW_PAXGROW} />;
// };

// export default BoneMarrowTransplantPage;

// src/pages/treatments/BoneMarrowTransplantPage.jsx
import React from "react";
import TreatmentTemplate from "./TreatmentTemplate";
import { Award, Users, Shield, Clock, Calendar, Activity, ThumbsUp, Heart, Droplets } from "lucide-react";

const BONE_MARROW_TREATMENT = {
  slug: "bone-marrow-transplant",
  name: "Bone Marrow Transplant",
  shortName: "BMT",
  tagline: "A Second Chance at Life",
  heroSubtag: "Save 70–80% on BMT. World-class haematology centres. No waiting list for donors.",
  description:
    "Comprehensive bone marrow transplant services including autologous and allogeneic transplants for leukaemia, lymphoma, thalassaemia, and other blood disorders. Our centres perform over 500 transplants annually with outcomes matching leading US and European centres, supported by dedicated stem cell laboratories and 24/7 haematology intensivist coverage.",
  heroImage: "/BoneMarrow.jpeg",
  category: "Haematology & Oncology",
  badge: "Life-Saving",
  accentColor: "red",
  costCard: {
    label: "Complete BMT package (autologous)",
    value: "$14,500–$22,000",
    compare: "vs. $55,000+ in the UK",
    stay: "4–6 weeks isolation + 4–8 weeks recovery",
    stayCompare: "vs. $250,000–$500,000 in the US",
  },
  stats: [
    { label: "Success Rate", value: "85%+", icon: Award },
    { label: "Transplants/Year", value: "500+", icon: Users },
    { label: "Years Experience", value: "25+", icon: Shield },
    { label: "ICU Stay", value: "2-4 Weeks", icon: Clock },
  ],
  benefits: [
    "Autologous & allogeneic (matched sibling, matched unrelated, haploidentical) transplants",
    "Dedicated BMT units with HEPA filtration and positive pressure isolation rooms",
    "Stem cell harvesting and cryopreservation on-site",
    "24/7 haematology intensive care specialist coverage",
    "Comprehensive pre-transplant workup and conditioning protocols",
    "Nutritional support including parenteral nutrition when needed",
    "Post-transplant monitoring and long-term follow-up programme",
    "Insurance pre-authorisation and international patient support",
  ],
  procedure: [
    {
      step: "01",
      title: "Evaluation & Workup",
      desc: "HLA typing, disease staging, organ function tests, and donor search.",
      duration: "2-4 Weeks",
      icon: Calendar,
    },
    {
      step: "02",
      title: "Stem Cell Harvesting",
      desc: "Peripheral blood stem cell collection or bone marrow harvest under anaesthesia.",
      duration: "1-2 Days",
      icon: Activity,
    },
    {
      step: "03",
      title: "Conditioning & Transplant",
      desc: "Chemotherapy/radiation conditioning followed by stem cell infusion.",
      duration: "7-10 Days",
      icon: ThumbsUp,
    },
    {
      step: "04",
      title: "Engraftment & Recovery",
      desc: "Neutrophil/platelet engraftment, infection prevention, and gradual recovery.",
      duration: "4-8 Weeks",
      icon: Heart,
    },
  ],
  faqs: [
    {
      q: "What is the difference between autologous and allogeneic BMT?",
      a: "Autologous transplant uses your own stem cells (harvested before high-dose chemo). Allogeneic transplant uses stem cells from a donor — usually a matched sibling or unrelated donor. The choice depends on your disease, age, and overall health.",
    },
    {
      q: "How long does recovery take after BMT?",
      a: "Hospital stay is typically 4-6 weeks for isolation and monitoring. Full immune recovery takes 6-12 months. Most patients return to normal activities within 3-6 months, but regular follow-up is essential for at least 2 years.",
    },
    {
      q: "What are the success rates for BMT in India?",
      a: "Success rates vary by disease and transplant type. For autologous transplants in multiple myeloma, 5-year survival exceeds 80%. For allogeneic transplants in leukaemia, 5-year survival ranges from 50-70% — comparable to leading Western centres.",
    },
    {
      q: "Can international patients find matching donors in India?",
      a: "Yes. India has a large and diverse stem cell donor registry. For patients requiring haploidentical (half-matched) transplants, India's large population often yields suitable family donors. We also coordinate with international registries when needed.",
    },
    {
      q: "What support is available for international patients?",
      a: "PaxGrow provides complete support including visa assistance, airport pickup, accommodation near the hospital for accompanying family, translation services, daily updates to family back home, and telemedicine follow-up after returning home.",
    },
  ],
  doctors: [
    {
      name: "Dr. Punit Jain",
      specialty: "Haematologist & BMT Physician",
      experience: "22 Years",
      rating: 4.9,
      reviews: 1800,
      image: "https://randomuser.me/api/portraits/men/41.jpg",
      qualifications: "MBBS, MD, DM (Clinical Haematology)",
      hospital: "Apollo Hospitals, Chennai",
    },
    {
      name: "Dr. Reena Nair",
      specialty: "Haematologist & BMT Specialist",
      experience: "28 Years",
      rating: 4.9,
      reviews: 2200,
      image: "https://randomuser.me/api/portraits/women/51.jpg",
      qualifications: "MBBS, MD, FRCP (Glasg)",
      hospital: "Tata Medical Center, Kolkata",
    },
    {
      name: "Dr. Manoj Kumar",
      specialty: "Paediatric Haematologist & BMT Physician",
      experience: "18 Years",
      rating: 4.8,
      reviews: 1600,
      image: "https://randomuser.me/api/portraits/men/61.jpg",
      qualifications: "MBBS, MD, DM (Paediatric Haematology-Oncology)",
      hospital: "Fortis Memorial Research Institute, Gurugram",
    },
  ],
  testimonials: [
    {
      name: "Ahmed Hassan",
      age: 45,
      location: "Nairobi, Kenya",
      text: "Diagnosed with multiple myeloma. My doctors back home said BMT was my best chance but the cost was prohibitive. PaxGrow arranged everything — from evaluation to transplant and follow-up. Today I'm in remission. Grateful beyond words.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/men/71.jpg",
      treatment: "Autologous BMT for Multiple Myeloma",
      date: "October 2023",
    },
    {
      name: "Fatima Begum",
      age: 32,
      location: "Dhaka, Bangladesh",
      text: "My 6-year-old daughter needed a bone marrow transplant for thalassaemia. The team found a matched unrelated donor and the transplant was successful. The care during isolation was exceptional. We never felt alone.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/women/62.jpg",
      treatment: "Allogeneic BMT for Thalassaemia",
      date: "February 2024",
    },
    {
      name: "Michael Okafor",
      age: 38,
      location: "Lagos, Nigeria",
      text: "Four rounds of chemotherapy failed to control my lymphoma. The allogeneic transplant was intense, but the medical team supported me through every complication. One year post-transplant, I'm cancer-free and back to work.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/men/81.jpg",
      treatment: "Allogeneic BMT for Lymphoma",
      date: "June 2023",
    },
  ],
};

const BONE_MARROW_PAXGROW = {
  whyIndiaSubtitle: "WHY PAXGROW + INDIA",
  whyIndiaTitle: "Why International Patients Choose India for BMT",
  whyIndiaReasons: [
    "India performs 2,500+ BMTs annually with outcomes matching Western centres",
    "JCI/NABH accredited BMT units with dedicated isolation facilities",
    "Haematologists trained at leading US and UK transplant centres",
    "Cost savings of 70–80% including donor search and stem cell processing",
  ],
  conditionsTitle: "Conditions Treated with Bone Marrow Transplant",
  conditions: [
    "Acute Leukaemia (AML, ALL)",
    "Chronic Leukaemia (CML, CLL)",
    "Lymphoma (Hodgkin & Non-Hodgkin)",
    "Multiple Myeloma",
    "Thalassaemia Major",
    "Sickle Cell Disease",
    "Aplastic Anaemia",
    "Myelodysplastic Syndrome (MDS)",
    "Severe Combined Immunodeficiency (SCID)",
    "Autoimmune Disorders (selected cases)",
  ],
  stayValue: "4–6 weeks hospital + 4–8 weeks recovery in India (total 8–14 weeks recommended)",
  costTitle: "Why India for Bone Marrow Transplant?",
  costRows: [
    {
      procedure: "Autologous BMT (including stem cell harvest)",
      india: "$14,500–$22,000",
      africa: "$35,000–$60,000",
      ukusa: "$150,000–$300,000",
    },
    {
      procedure: "Allogeneic BMT (matched sibling donor)",
      india: "$18,000–$26,500",
      africa: "$45,000–$75,000",
      ukusa: "$250,000–$500,000",
    },
    {
      procedure: "Allogeneic BMT (matched unrelated donor)",
      india: "$22,000–$34,000",
      africa: "$55,000–$100,000",
      ukusa: "$300,000–$600,000",
    },
  ],
};

const BoneMarrowTransplantPage = () => {
  return <TreatmentTemplate treatment={BONE_MARROW_TREATMENT} paxgrowData={BONE_MARROW_PAXGROW} />;
};

export default BoneMarrowTransplantPage;